/**
=========================================================
* Soft UI Dashboard PRO React - v4.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// @mui material components
import Icon from "@mui/material/Icon";
import Tooltip from "@mui/material/Tooltip";

// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";

function ActionCell({ handleDeleteAction, handleEditAction, handleCheckCloneAction }) {
  return (
    <SoftBox display="flex" alignItems="center">
      <SoftBox mx={2}>
        <SoftTypography variant="body1" color="secondary" sx={{ cursor: "pointer", lineHeight: 0 }}>
          <Tooltip title="Edit Market Setting" placement="top">
            <Icon onClick={handleEditAction}>edit</Icon>
          </Tooltip>
        </SoftTypography>
      </SoftBox>
      <SoftBox mx={2}>
        <SoftTypography variant="body1" color="secondary" sx={{ cursor: "pointer", lineHeight: 0 }}>
          <Tooltip title="Check Clone MarketSetting to Another Platform" placement="top">
            <Icon className={""} onClick={handleCheckCloneAction}>
              move_up_icon{" "}
            </Icon>
          </Tooltip>
        </SoftTypography>
      </SoftBox>
      <SoftBox mx={2}>
        <SoftTypography variant="body1" color="secondary" sx={{ cursor: "pointer", lineHeight: 0 }}>
          <Tooltip title="Delete Market Setting" placement="top">
            <Icon onClick={handleDeleteAction}>delete</Icon>
          </Tooltip>
        </SoftTypography>
      </SoftBox>
    </SoftBox>
  );
}

// Typechecking props of the CreateTemplate
ActionCell.propTypes = {
  handleDeleteAction: PropTypes.func,
  handleEditAction: PropTypes.func,
  handleCheckCloneAction: PropTypes.func,
};

export default ActionCell;
